module.exports = __webpack_public_path__ + "img/L1060680.3b201a62.jpg";